import React from "react";
import {useOverrides} from "@quarkly/components";
import {Text, Box, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "60px 0",
    "sm-padding": "40px 0",
    "color": "--dark",
    "background": "--color-white",
    "id": "faq"
};
const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "margin": "-16px -16px -16px -16px",
            "display": "flex",
            "flex-wrap": "wrap"
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "padding": "16px 16px 16px 16px",
            "width": "33.333%",
            "md-width": "100%"
        }
    },
    "box2": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "as": "h2",
            "font": "--headline1",
            "margin": "0 0 8px 0",
            "children": "FAQs"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--lead",
            "margin": "0",
            "color": "--greyD2",
            "children": "Потрібні відповіді? У нас вони є!"
        }
    },
    "box3": {
        "kind": "Box",
        "props": {
            "padding": "16px 16px 16px 16px",
            "width": "66.66%",
            "md-width": "100%"
        }
    },
    "box4": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "row",
            "flex-wrap": "wrap"
        }
    },
    "box5": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "50%",
            "padding": "16px 16px 16px 16px",
            "sm-width": "100%"
        }
    },
    "box6": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "12px 0",
            "children": "Чи потрібні мені навички програмування?"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "12px 0",
            "color": "--greyD2",
            "children": "Ні, Code Zero Visual Trading розроблений так, щоб бути повністю доступним без програмування. Створюйте, тестуйте та автоматизуйте стратегії візуально!"
        }
    },
    "box7": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "50%",
            "padding": "16px 16px 16px 16px",
            "sm-width": "100%"
        }
    },
    "box8": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "12px 0",
            "children": "Які типи торгових стратегій підтримуються?"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "12px 0",
            "color": "--greyD2",
            "children": "Code Zero підтримує різноманітні стратегії, включаючи стратегії слідування за трендом, робота в діапазоні, сіткові стратегії."
        }
    },
    "box9": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "50%",
            "padding": "16px 16px 16px 16px",
            "sm-width": "100%"
        }
    },
    "box10": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text6": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "12px 0",
            "children": "Чи можна інтегрувати користувацькі індикатори?"
        }
    },
    "text7": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "12px 0",
            "color": "--greyD2",
            "children": "Так! Code Zero дозволяє використовувати як стандартні індикатори TradingView, так і користувацькі індикатори, створені спільнотою TradingView."
        }
    },
    "box11": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "50%",
            "padding": "16px 16px 16px 16px",
            "sm-width": "100%"
        }
    },
    "box12": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text8": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "12px 0",
            "children": "Як налаштувати сповіщення?"
        }
    },
    "text9": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "12px 0",
            "color": "--greyD2",
            "children": "Ви можете налаштувати надсилання сповіщень через Telegram або будь-яку іншу зовнішню систему за допомогою відправки webhook-повідомлень."
        }
    }
};

const CdzvFaqUA = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Box {...override("box")}>
            <Box {...override("box1")}>
                <Box {...override("box2")}>
                    <Text {...override("text")} />
                    <Text {...override("text1")} />
                </Box>
            </Box>
            <Box {...override("box3")}>
                <Box {...override("box4")}>
                    <Box {...override("box5")}>
                        <Box {...override("box6")}>
                            <Text {...override("text2")} />
                            <Text {...override("text3")} />
                        </Box>
                    </Box>
                    <Box {...override("box7")}>
                        <Box {...override("box8")}>
                            <Text {...override("text4")} />
                        </Box>
                        <Text {...override("text5")} />
                    </Box>
                    <Box {...override("box9")}>
                        <Box {...override("box10")}>
                            <Text {...override("text6")} />
                            <Text {...override("text7")} />
                        </Box>
                    </Box>
                    <Box {...override("box11")}>
                        <Box {...override("box12")}>
                            <Text {...override("text8")} />
                            <Text {...override("text9")} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvFaqUA, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvFaqUA;